// De lading zichtbaar op de bak: producten wiebelen mee in bochten, warm eten dampt, ijs druppelt,
// en beschadigde producten hangen scheef met een rood uitroepteken.
// Methoden worden op BezorgerGame.prototype gezet (zie game/mixins.js).

const EMOJI_FONT = 'system-ui, "Apple Color Emoji", "Segoe UI Emoji", sans-serif';

export class RenderCargoMixin {
  renderCargo(ctx) {
    const loaded = this.shift?.loaded;
    if (!loaded?.length || this.mode !== 'shift') return;
    const s = this.scooter;
    // Altijd minstens ~17 schermpixels groot, ook als de camera ver is uitgezoomd
    const size = Math.max(26, 17 / this.camera.zoom);
    // Recht boven de scooter, welke kant hij ook op rijdt
    const bx = s.x;
    const by = s.y - size * 1.5 - (s.jumpZ || 0);
    const gap = 4;
    const width = loaded.length * (size + gap) + gap;
    const t = this.time;

    ctx.save();
    ctx.translate(bx, by);
    ctx.rotate(this.cargoWobble.angle);

    // Dienblad
    ctx.fillStyle = 'rgba(28, 25, 23, 0.72)';
    ctx.beginPath();
    ctx.roundRect(-width / 2, -size / 2 - 5, width, size + 10, 10);
    ctx.fill();

    ctx.font = `${size}px ${EMOJI_FONT}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    loaded.forEach((o, i) => {
      const x = -width / 2 + gap + size / 2 + i * (size + gap);
      const damaged = 1 - o.integrity / 100;
      ctx.save();
      ctx.translate(x, 0);
      // Beschadigd gebak hangt scheef, kwetsbaar spul wiebelt extra
      ctx.rotate(damaged * 0.5 * (i % 2 ? 1 : -1) + this.cargoWobble.angle * (o.product.sensitivity - 1) * 0.4);
      ctx.globalAlpha = 0.55 + 0.45 * (o.integrity / 100);
      ctx.fillText(o.product.icon, 0, 1);
      ctx.restore();

      // Damp boven warme producten, zolang ze nog warm zijn
      if (o.product.heat === 'warm' && o.temp > 30) {
        ctx.save();
        ctx.globalAlpha = 0.35 * (o.temp / 100);
        ctx.fillStyle = '#f5f5f4';
        for (let k = 0; k < 2; k++) {
          const phase = (t * 0.9 + k * 0.5 + i * 0.3) % 1;
          ctx.beginPath();
          ctx.arc(x + Math.sin(t * 3 + k * 2 + i) * 4, -size / 2 - 6 - phase * 18, 3 + phase * 4, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }
      // Smeltende ijstaart druppelt
      if (o.product.heat === 'koud' && o.temp < 75) {
        ctx.save();
        ctx.fillStyle = '#7dd3fc';
        const phase = (t * 1.4 + i * 0.37) % 1;
        ctx.globalAlpha = 0.8 * (1 - phase);
        ctx.beginPath();
        ctx.arc(x + 6, size / 2 + phase * 14, 2.5, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      // Rood uitroepteken bij flinke schade
      if (o.integrity < 50) {
        ctx.save();
        ctx.fillStyle = '#ef4444';
        ctx.beginPath();
        ctx.arc(x + size / 2 - 3, -size / 2 + 1, size * 0.28, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#ffffff';
        ctx.font = `800 ${Math.round(size * 0.45)}px "Plus Jakarta Sans Variable", system-ui, sans-serif`;
        ctx.fillText('!', x + size / 2 - 3, -size / 2 + 1.5);
        ctx.restore();
      }
    });
    ctx.restore();
  }
}
